(function () {
    'use strict';

    angular
        .module('EventListApp')
        .controller('ContactUsCtrl', contactUsCtrl);

    contactUsCtrl.$inject = ['$scope', '$translation', 'ApiFactory'];

    function contactUsCtrl($scope, $translation, ApiFactory) {
        const vm = this;
        vm.recordTimelimit = 100;
        let translationKeys = {
            messageFailed: 'messageFailed',
            messageSuccess: 'messageSuccess',
            connectionError: 'connectionError',
            unsupported: 'unsupported',
            recording: 'recording',
        };

        let enTranslations = {
            'recording': 'recording...',
            'finished': 'Message recorded  ',
            'recordMsg': 'Record message',
            'finishRec': 'Click to finish',
            'reRecord': 'Recored again',
            'noMicAccess': 'No access to microphone',
            'unsupported': 'Your browser is currently unsupported',
            'messageFailed': "Sorry $name, message delivery failed. check your input and try again",
            'messageSuccess': "Your message has been sent.",
            'connectionError': "Sorry $name, it seems that my mail server is not responding. Please try again later!"
        }

        let heTranslations = {
            'recording': 'מקליט...',
            'finished': 'הודעה הוקלטה  ',
            'recordMsg': 'הקלטת הודעה',
            'finishRec': 'סיום הקלטה',
            'noMicAccess': 'אין גישה למיקרופון',
            'reRecord': 'שינוי הקלטה',
            'unsupported': 'הדפדפן שלך אינו נתמך',
            'messageFailed': "סליחה $name, שליחת ההודעה נכשלה. יש לבדוק את הנתונים ולנסות שוב",
            'messageSuccess': "ההודעה שלך נשלחה",
            'connectionError': "אנו מתצלים $name, נראה ששרת ההודעות שלנו לא מגיב. נא לנסות מאוחר יותר"
        }

        vm.form = {};
        let webID = 0, code, lang;

        $translation
            .addTranslation('en', enTranslations)
            .addTranslation('he', heTranslations);

        vm.init = function (eventID, evCode, lng) {
            code = evCode;
            lang = lng;

            if (typeof getWebID == 'function')
                webID = getWebID();

            if (typeof Ea_eventact == 'function')
                Ea_eventact(eventID, false, '', lang, webID, 6);
        }

        vm.recInProgress = function (isProgress) {
            vm.inProgress = isProgress;
        }

        vm.sendMessage = function () {
            vm.submitted = true;
            vm.form.secret = document.getElementById('secret')?.value ?? '';
            // secret is hidden to check bot input
            // must be empty
            if ($scope.contactForm.$invalid || $scope.contactForm.secret || vm.inProgress)
                return false;

            let firstName = angular.copy(vm.form.name); // For Success/Failure Message
            if (firstName.indexOf(' ') >= 0)
                firstName = firstName.split(' ').slice(0, -1).join(' ');

            vm.form.code = code;
            vm.form.lang = lang;
            vm.form.webID = webID;

            vm.inProgress = true;
            ApiFactory.SendMessage(vm.form)
                .then(function (response) {
                    if (response.data.success) {
                        vm.result = $translation.translateAll(translationKeys.messageSuccess);
                        vm.mailSuccess = true;
                    }
                    else {
                        if (response.data.errorMsg)
                            vm.result = response.data.errorMsg;
                        else
                            vm.result = $translation.translateAll(translationKeys.messageFailed).replace('$name', firstName);
                    }
                })
                .catch(function (response) {
                    vm.mailSuccess = false;
                    vm.result = $translation.translateAll(translationKeys.connectionError).replace('$name', firstName);
                }).finally(function () {
                    vm.inProgress = false;
                })
        };

    }
})();
